import React from 'react';
import { motion } from 'framer-motion';

const About: React.FC = () => {
  return (
    <motion.section id="about" className="about" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
      <h2>Why Choose Wevatar for Your Digital Success</h2>
      <p className="section-subtitle">
        We're not just developers – we're your digital growth partners. With a passion for innovation and a commitment to excellence, we transform ideas into digital realities that drive business success.
      </p>
      <div className="about-content about-grid">
        <div className="about-block">
          <h3>🚀 Innovation First</h3>
          <p>We stay ahead of the curve with the latest technologies and design trends. Our solutions are built for tomorrow, ensuring your business remains competitive in the ever-evolving digital landscape.</p>
        </div>
        <div className="about-block">
          <h3>⚡ Performance Driven</h3>
          <p>Speed matters. We optimize every aspect of your digital presence for lightning-fast loading times, seamless user experiences, and maximum conversion rates that boost your bottom line.</p>
        </div>
        <div className="about-block">
          <h3>🎯 Results Focused</h3>
          <p>Every pixel, every line of code serves a purpose. We design and develop with clear objectives in mind, ensuring your digital investments deliver measurable returns and tangible business growth.</p>
        </div>
        <div className="about-block">
          <h3>🤝 Partnership Approach</h3>
          <p>Your success is our success. We work closely with you throughout the entire process, from initial concept to launch and beyond, providing ongoing support and strategic guidance.</p>
        </div>
        <div className="about-block">
          <h3>🔒 Security First</h3>
          <p>Your data and your users' trust are paramount. We implement enterprise-grade security measures and best practices to protect your digital assets and maintain customer confidence.</p>
        </div>
        <div className="about-block">
          <h3>💡 Creative Excellence</h3>
          <p>Beautiful design meets powerful functionality. We blend artistic vision with technical expertise to create digital experiences that captivate, engage, and convert your audience.</p>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
